import { ArrowLeft } from "lucide-react";
import { useEffect } from "react";
import { Link } from "react-router-dom";

import { Seo } from "@/components/landing/Seo";
import { FinalCta, LandingNav, useReveal } from "@/components/landing/Sections";

const TODO = <mark className="lp-todo">[à compléter]</mark>;
const Field = ({ children }) => <mark className="lp-todo">[{children}]</mark>;

export default function LegalPage() {
  useReveal();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="lp" data-testid="legal-page">
      <Seo path="/mentions-legales" />
      <LandingNav />
      <main className="lp-legalpage lp-wrap">
        <Link to="/" className="lp-legalpage-back" data-testid="legal-back"><ArrowLeft size={14} />Retour à l'accueil</Link>
        <h1>Mentions légales</h1>
        <section>
          <h2>Éditeur du site</h2>
          <p>Raison sociale : AIRTHERMO — Cabinet de courtage en énergie<br />Siège social : 5 allée de la Grande Treille, 35200 Rennes<br />Téléphone : 02 55 99 77 58 · E-mail : contact@airthermo.fr</p>
          <p>Forme juridique : SARL · Capital social : {TODO}<br />SIRET : 940 278 740 00011 · SIREN : 940 278 740 · Ville d'immatriculation au RCS : {TODO}<br />Directeur de la publication : <Field>DIRECTEUR DE LA PUBLICATION</Field></p>
        </section>
        <section>
          <h2>Hébergement</h2>
          <p>Hébergeur du site : <Field>HÉBERGEUR : nom, adresse</Field></p>
        </section>
        <section>
          <h2>Données personnelles</h2>
          <p>Le traitement de vos données personnelles est décrit dans notre <Link to="/politique-de-confidentialite" data-testid="legal-privacy-link">politique de confidentialité</Link>.</p>
        </section>
        <section>
          <h2>Propriété intellectuelle</h2>
          <p>Les textes, logos et visuels de ce site sont la propriété d'AIRTHERMO ou de leurs auteurs respectifs. Toute reproduction sans autorisation est interdite.</p>
        </section>
      </main>
      <FinalCta />
    </div>
  );
}
